import HighchartsReact from "highcharts-react-official";

import { HighCharts as Chart } from "@/features/shared/components";

type Props = {
  data: HighchartsReact.Props["options"];
};

const HighCharts = ({ data }: Props) => {
  return <Chart options={data} />;
};

export default HighCharts;
